import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { ComponentProps } from "react";
const parseQueryParams = (query: string) => {
  return query ? Object.fromEntries(new URLSearchParams(query)) : {};
};

const stringifyQueryParams = (params: Record<string, string>) => {
  return "?" + new URLSearchParams(params).toString();
};

const UTMLink = ({
  to,
  children,
  ...otherProps
}: { to: string; children: React.ReactNode } & ComponentProps<typeof Link>) => {
  const location = useLocation();
  const currentParams = parseQueryParams(location.search);
  const [baseTo, searchParams] = to.split("?");
  const targetParams = parseQueryParams(searchParams);

  const mergedParams = { ...currentParams, ...targetParams };

  const newTo = `${baseTo}${stringifyQueryParams(mergedParams)}`;

  return (
    // @ts-expect-error Type 'GatsbyLink<unknown> | null' is not assignable to type 'HTMLAnchorElement | null'.
    <Link to={newTo} {...otherProps}>
      {children}
    </Link>
  );
};

export default UTMLink;
